import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { AvatarGroupSize } from './types'

@safeCustomElement('mdc-avatar-group')
export class MdcAvatarGroup extends LitElement {
  @property({ type: String }) size: AvatarGroupSize = 'md'

  static styles = css`
    :host {
      display: block;
      font-family: var(--typography-font-family-sans);
    }
    .mdc-avatar-group {
      display: flex;
    }
    ::slotted(*) {
      box-shadow: 0 0 0 2px var(--color-functional-gray-white);
    }
    ::slotted(*:not(:first-child)) {
      margin-left: calc(var(--spacing-050, 0.5rem) * -1);
    }
  `

  connectedCallback() {
    super.connectedCallback()
    this._updateChildSizes()
  }

  updated(changedProperties: Map<PropertyKey, unknown>) {
    super.updated(changedProperties)
    if (changedProperties.has('size')) {
      this._updateChildSizes()
    }
  }

  private _updateChildSizes() {
    const avatars = this.querySelectorAll('mdc-avatar')
    avatars.forEach((avatar) => {
      avatar.setAttribute('size', this.size)
    })
  }

  render() {
    return html`<div class="mdc-avatar-group"><slot></slot></div>`
  }
}
